import { render, staticRenderFns } from "./Puerta.vue?vue&type=template&id=64008832&"
import script from "./Puerta.vue?vue&type=script&lang=js&"
export * from "./Puerta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports